import styled from 'styled-components';

export const IpsativeResponsesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  margin-top: 12px;
`;

export const AnswerOption = styled.div<{ selected?: boolean }>`
  padding: 10px;
  border: 2px solid ${({ selected }) => (selected ? 'var(--ion-color-primary)' : '#e0e0e0')};
  border-radius: 12px;
  color: ${({ selected }) => (selected ? '#ffffff' : 'var(--ion-color-primary)')};
  background-color: ${({ selected }) => (selected ? 'var(--ion-color-primary-tint)' : '#ffffff')};
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 14px;
  line-height: 1.4;

  &:active {
    transform: scale(0.98);
  }
`;
